<template>
  <div class="__page_cont" v-if="user_code">
    <div class="hd">
      <h3 class="tit">{{ user_code_info.code }} 코드 상세 / <em class="c_free">프리매치({{ user_code_info.match_rate * 100 }}%)</em> / <em class="c_live">라이브({{ user_code_info.live_rate * 100 }}%)</em></h3>
    </div>
    <div class="bd">
<!--      <div class="info_summary">
        <span style="float:right;">
        <date-range-picker
          v-model="dateRange"
          opens="left"
          :locale-data="dateRangeConfig.locale"
          :linkedCalendars="dateRangeConfig.linkedCalendars"
          :showCustomRangeLabel="dateRangeConfig.showCustomRangeLabel"
          :alwaysShowCalendars="dateRangeConfig.alwaysShowCalendars"
          :applyButtonClasses="dateRangeConfig.applyButtonClasses"
          :ranges="dateRangeConfig.ranges"
          @update="updateRanges"
          applyButtonClasses="_btn_st1"
        />
        </span>
      </div>-->
      <table class="horiz_tbl" border="0">
        <thead>
        <tr>
          <th width="50px">No.</th>
          <th class="line" width="100px">상태</th>
          <th class="line">닉네임</th>
          <th class="line" width="150px">가입일자</th>
          <th class="line" width="130px">프리매치 참여골드</th>
          <th width="130px">지급골드</th>
          <th class="line" width="130px">라이브 참여골드</th>
          <th width="130px">지급골드</th>
          <th class="line" width="130px">전체지급골드</th>
        </tr>
        </thead>
        <tbody>

        <tr v-for="(row, key) in child">
          <td>{{ key + 1 }}</td>
          <td class="line">정상</td>
          <td class="line">{{ row.nickname }}</td>
          <td class="line">{{ row.writedate }}</td>
          <td class="line">{{ numberToString(row.match_bet_amount) }}</td>
          <td class="c_free">{{ numberToString(row.match_amount) }}</td>
          <td class="line">{{ numberToString(row.live_bet_amount) }}</td>
          <td class="c_live">{{ numberToString(row.live_amount) }}</td>
          <td class="c_000 line">{{ numberToString(row.live_amount + row.match_amount) }}</td>
        </tr>

        <tr v-if="child.length <= 0">
          <td colspan="9">데이터가 없습니다.</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
export default {
  name: "partner-code-child",
  components: {
    DateRangePicker,
    InfiniteLoading
  },
  data() {
    const today =  moment().toDate();
    const now = moment().format('YYYY-MM-DD')
    const fromDate = moment().add(-1, 'months').format('YYYY-MM-DD')
    return {
      page: 1,
      totalPage: 1,
      totalCount: 0,
      pageSize: 12,
      limit: 20,
      from : fromDate,
      to : now,
      search : '',
      dateRange: {
        startDate : fromDate,
        endDate : now
      },
      dateRangeConfig : {
        linkedCalendars: false,
        showCustomRangeLabel: false,
        alwaysShowCalendars: true,
        applyButtonClasses: '_btn_st1',
        ranges: {
          '오늘': [today, today]
          , '1주일': [moment().subtract(7, 'days').toDate(), today]
          , '1개월': [moment().subtract(1, 'month').toDate(), today]
          , '3개월': [moment().subtract(3, 'month').startOf('month').toDate(), today]
          , '6개월': [moment().subtract(6, 'month').startOf('month').toDate(), today]
        },
        locale : {
          direction: 'ltr',
          firstDay: 0,
          format: 'yyyy-mm-dd',
          separator: ' ~ ',
          applyLabel: '확인',
          cancelLabel: '취소',
          weekLabel: '주',
          customRangeLabel: '기간',
          daysOfWeek: ['일', '월', '화', '수', '목', '금', '토'],
          monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        },
      },
    }
  },
  created() {
    this.infiniteHandler()
  },
  methods:{
    updateRanges(){
      this.dateRange = {
        startDate : this.startDate,
        endDate : this.endDate,
      }

      this.page = 1
      this.$store.dispatch('partner/setChild',[])
      this.infiniteHandler()
    },
    infiniteHandler() {
      let list = this.child
      this._get("/v1/partner/child", this.condition).then(({ data }) => {

        if (data.childs.length > 0) {
          this.page += 1;
          list = list.concat(data.childs);

          this.$store.dispatch('partner/setChild',list)
          this.$store.dispatch('partner/setCodeInfo',data.info)

        } else {
        }

        this.totalPage = data.totalPage
        this.pageSize = data.pageSize
        this.totalCount = data.totalCount
      });
    },
  },
  computed: {
    condition() {
      return {
        code: this.user_code,
        page: this.page,
        from: this.startDate,
        to: this.endDate
      }
    },
    child() {
      return this.$store.getters['partner/child'];
    },
    user_code() {
      return this.$store.getters['partner/user_code'];
    },
    user_code_info() {
      return this.$store.getters['partner/user_code_info'];
    },
    startDate() {
      return this.$store.getters['partner/startDate'];
    },
    endDate() {
      return this.$store.getters['partner/endDate'];
    },
  },
  watch: {
    user_code(to) {
      if (this.page > 1) {
        this.page = 1
        this.$store.dispatch('partner/setChild',[])
        this.infiniteHandler()
      }
    },
    startDate(to) {
      this.page = 1
      this.$store.dispatch('partner/setChild',[])
      this.infiniteHandler()
    },
    endDate(to) {
      this.page = 1
      this.$store.dispatch('partner/setChild',[])
      this.infiniteHandler()
    },
  },

}
</script>

<style scoped>
.ly_history .no-results {margin-top:-250px; height:250px; line-height:250px; color:#000;}
</style>



// WEBPACK FOOTER //
// src/components/partner/partner-code-child.vue